module.exports = __webpack_public_path__ + "img/back_skirt_length_asymmetric.2217f34e.png";